var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Raggruppa_2016",
    "data-name": "Raggruppa 2016",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 265.729,
    height: 50.728,
    viewBox: "0 0 265.729 50.728",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_2795",
    "data-name": "Rettangolo 2795",
    width: 265.728,
    height: 50.728,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2015",
    "data-name": "Raggruppa 2015",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2014",
    "data-name": "Raggruppa 2014",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_10531",
    "data-name": "Tracciato 10531",
    d: "M17.93,14.869V9.912H4.956V4.956H17.93V0H0V25.363A20.411,20.411,0,0,0,17.93,45.622v5.106h4.956V45.622a20.411,20.411,0,0,0,17.93-20.259V0H22.886V4.956H35.859V9.912H22.886v4.956H35.859V25.363a15.451,15.451,0,1,1-30.9,0V14.869Z",
    transform: "translate(0 0)",
    fill: "#fab725"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_10532",
    "data-name": "Tracciato 10532",
    d: "M141.3,38.775a8.368,8.368,0,0,1-6.9-3.068,8.5,8.5,0,0,1-1.4-5.117V19.876h-2.624V17.453h8.348v2.423H136.1V30.562a6.4,6.4,0,0,0,.785,3.351A5.019,5.019,0,0,0,141.3,36a4.946,4.946,0,0,0,4.417-2.145,6.607,6.607,0,0,0,.785-3.323V19.876h-2.624V17.453h8.318v2.423H149.6V30.591a8.936,8.936,0,0,1-1.459,5.115,8.131,8.131,0,0,1-6.843,3.07",
    transform: "translate(-19.268 -2.579)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_10533",
    "data-name": "Tracciato 10533",
    d: "M182.2,38.422H169.076V19.876h-2.595V17.454H181.7v4.988h-2.717V20.023h-6.807v6.542h7.371v2.569h-7.371v6.718h7.308V33.346H182.2Z",
    transform: "translate(-24.604 -2.58)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_10534",
    "data-name": "Tracciato 10534",
    d: "M81.067,38.422H67.942V19.876H65.347V17.454H80.566v4.988H77.849V20.023H71.043v6.542h7.371v2.569H71.043v6.718H78.35V33.346h2.717Z",
    transform: "translate(-9.658 -2.58)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_10535",
    "data-name": "Tracciato 10535",
    d: "M203.068,38.714c-3.451,0-6.946-1.545-6.946-4.5V31.958h2.864v1.609c0,1.179,1.4,2.372,4.081,2.372,2.5,0,4.052-1.191,4.052-3.109,0-2.223-2.091-3.033-4.512-3.97l-.452-.176c-2.491-.937-5.591-2.1-5.591-5.967,0-4.187,3.481-5.678,6.739-5.678,3.173,0,6.386,1.211,6.386,3.526v2.523H206.8v-1.52c0-1.157-1.8-1.782-3.492-1.782-1.731,0-3.58.731-3.58,2.784,0,2.1,1.946,2.842,4.2,3.7l.173.065c3.025,1.134,6.152,2.308,6.152,6.263,0,4.228-3.607,6.121-7.182,6.121",
    transform: "translate(-28.985 -2.518)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_10536",
    "data-name": "Tracciato 10536",
    d: "M233.624,38.422h-3.1v-18.4h-4.743v3.244h-2.717V17.454h18.02v5.813h-2.717V20.023h-4.743Z",
    transform: "translate(-32.967 -2.58)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_10537",
    "data-name": "Tracciato 10537",
    d: "M260.337,27.45h4.111a3.5,3.5,0,0,0,3.7-3.846,3.113,3.113,0,0,0-1.9-3.2,7.136,7.136,0,0,0-2.536-.378h-3.374Zm12.531,10.972h-1.845c-1.786,0-2.235-.341-2.955-1.6l-3.214-5.691a1.935,1.935,0,0,0-2.116-1.111h-2.4v8.4h-3.1V19.876h-2.6V17.454h9.1a11.833,11.833,0,0,1,3.857.446,5.389,5.389,0,0,1,3.679,5.468,5.711,5.711,0,0,1-4.259,5.885,2.651,2.651,0,0,1,.829.95l2.947,5.129c.317.547.682.64,1.379.64h.7Z",
    transform: "translate(-37.634 -2.58)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_10538",
    "data-name": "Tracciato 10538",
    d: "M297.294,19.785a7.691,7.691,0,0,0-7.591,7.944c0,4.6,3.335,8.209,7.591,8.209,4.24,0,7.561-3.607,7.561-8.209a7.677,7.677,0,0,0-7.561-7.944m0,18.929a10.767,10.767,0,0,1-10.779-10.985,10.611,10.611,0,0,1,3.107-7.606,10.791,10.791,0,0,1,7.672-3.085,10.621,10.621,0,0,1,10.779,10.691,10.768,10.768,0,0,1-10.779,10.985",
    transform: "translate(-42.344 -2.518)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_10539",
    "data-name": "Tracciato 10539",
    d: "M105.629,35.732a7.617,7.617,0,0,0,7.59-7.973,7.6,7.6,0,1,0-15.18,0,7.618,7.618,0,0,0,7.591,7.973m0,2.747A10.513,10.513,0,0,1,94.85,27.759a10.779,10.779,0,0,1,21.558,0,10.514,10.514,0,0,1-10.779,10.72",
    transform: "translate(-14.018 -2.518)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_2794",
    "data-name": "Rettangolo 2794",
    width: 2.619,
    height: 9.522,
    transform: "translate(90.301 29.827)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.a0308f496bb40518dfc3be388db07a74.svg";
export { ForwardRef as ReactComponent };